export const AUCTIONEER_DATA_TEMPLATE_NAME_MAX_LETTERS = 128;
export const auctioneerDataTemplateNameValidator = (t) => (input) => {
    let err = null;
    if (!input || !input.trim().length) {
        err = t('auctioneer-data-templates.validation.auctioneer-data-template-empty-name');
    } else if (input.trim().length > AUCTIONEER_DATA_TEMPLATE_NAME_MAX_LETTERS) {
        err = t('auctioneer-data-templates.validation.auctioneer-data-template-name-too-long', { maxLetters: AUCTIONEER_DATA_TEMPLATE_NAME_MAX_LETTERS });
    }
    return err;
};

export const auctioneerDataTemplateItemsValidator = (t, minQuantity, maxQuantity) => (input) => {
    let err = null;
    if (!input.length) {
        err = t('auctioneer-data-templates.validation.auctioneer-data-template-items-empty');
    } else if (input.some((item) => item.quantity < minQuantity)) {
        err = t('auctioneer-data-templates.validation.auctioneer-data-template-items-quantity-too-low', { minQuantity });
    } else if (input.some((item) => item.quantity > maxQuantity)) {
        err = t('auctioneer-data-templates.validation.auctioneer-data-template-items-quantity-too-high', { maxQuantity });
    } else if (input.reduce((a, currentValue) => a + currentValue.quantity, 0) > maxQuantity) {
        err = t('auctioneer-data-templates.validation.auctioneer-data-template-items-max-sum-quantity-exceeded', { maxQuantitySum: maxQuantity });
    }
    return err;
};
